<template>
  <div class="footer">
    <div>
      <div>
        <p>超对称（北京）科技有限公司 | copyright©2016-<span>{{current_year}}</span> 超对称科技.
          京ICP备14042647号</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'rootFooter',
    data () {
      return {
        current_year: new Date().getFullYear()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 3rem;
    background-color: #E6E6E6;
    font-size:1.4rem;
    text-align: center;
    z-index: 999;
    >div{
      margin: 0;
    }
    div {
      height: 100%;
      p {
        margin: 0 !important;
        line-height: 30px;
        color: #a6a6a8;

        &:first-child {
          margin-top: 1.4rem;
        }
      }
    }
    ul {
      float: right;
      height: 100%;

      li {
        float: left;
        list-style: none;
        height: 100%;
        margin-left: 3rem;

        a {
          line-height: 6rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rootFooter.vue